import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError, timeout } from 'rxjs/operators';
import { Global } from '../../global.constants';
import { ReadConfigService } from '../common/read-config.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(
    private http: HttpClient,
    private readConfigService: ReadConfigService) { }

  readonly rootUrl = this.readConfigService.getApiUrl();
  apiTimeout = this.readConfigService.getApiTimeout();
  reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });

  getPastDueInvoices(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_GET_PAST_DUE_INVOICES_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getDueInvoices(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_GET_DUE_INVOICES_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getPendingInvoices(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_GET_PENDING_INVOICES_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getPaidInvoices(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_GET_PAID_INVOICES_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getEmpACHStatus(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_CHECK_BANK_INFO_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  submitPayment(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_SUBMIT_PAYMENT_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  handleError() {
    return timeout(this.apiTimeout),
      catchError((err: any) => {
        return throwError(err || 'Server error');
      }),
      map((v: any) => {
        if (v) {
          return v;
        }
      });
  }
}
